import React, { useEffect, useState } from 'react' 
import WebMain from './WebMain'
import { useSearchParams } from 'react-router-dom'
import {  Menu,  } from 'antd'
import {useYhUpdateQuery, } from '../store/BnsKeJiApi'
import SketchDesc from './FrontSketchDesc'
import { useNavigate } from 'react-router-dom'
function FrontSketchClient() {
    const [param] = useSearchParams()
    const yh_id = param.get('yh_id')
    const yh_name = param.get('yh_name')
    const bxm_id = param.get('bxm_id')
    const bxm_name = param.get('bxm_name')
    // 右边菜单
    const [rightMenu, setRightMenu] = useState([])
    const {data: rightMenuData, isSuccess: rightMenuSuccess} = useYhUpdateQuery({yh_id:yh_id},{skip:!yh_id})
    useEffect(() => {
        if(rightMenuSuccess){
            if(rightMenuData.Status==='success'){
                console.log(rightMenuData.Result);
                
                // 提取菜单文字中的数字进行排序的函数
                const extractNumberFromText = (text) => {
                    const match = text.match(/\d+/);
                    return match ? parseInt(match[0], 10) : 0;
                };

                // 对菜单进行排序的函数
                const sortMenuByNumbers = (menuItems) => {
                    return [...menuItems].sort((a, b) => {
                        const numA = extractNumberFromText(a.bxmxq_name || '');
                        const numB = extractNumberFromText(b.bxmxq_name || '');
                        return numA - numB;
                    });
                };

                // 对子菜单进行排序的函数
                const sortChildrenByNumbers = (children) => {
                    return [...children].sort((a, b) => {
                        const numA = extractNumberFromText(a.bxmbb_name || '');
                        const numB = extractNumberFromText(b.bxmbb_name || '');
                        return numA - numB;
                    });
                };
                
                // 先对一级菜单进行排序
                const sortedChildren = sortMenuByNumbers(rightMenuData.Result.children || []);
                
                const arr = sortedChildren.map((item) => {
                    const {bxmxq_id, bxmxq_name, children} = item
                    // 对子菜单也进行排序
                    const sortedSubChildren = children ? sortChildrenByNumbers(children) : [];
                    
                    return {
                        key: `parent_${bxmxq_id}`, // 为一级菜单添加前缀避免冲突
                        label: bxmxq_name,
                        children: sortedSubChildren.map((child) => ({
                            key: `child_${child.bxmbb_id}`, // 为二级菜单添加前缀避免冲突
                            label: child.bxmbb_name
                        }))
                    }
                })

                setRightMenu(arr)
            }
        }
    },[rightMenuData,rightMenuSuccess])
    const [bxmxq_id,setBxmxq_id] = useState('')
    const [currentMenuData, setCurrentMenuData] = useState(null)
    const [openKeys, setOpenKeys] = useState([])
    
    useEffect(() => {
        if(rightMenuSuccess && rightMenu && rightMenu.length > 0){
            console.log('rightMenu:', rightMenu);
            // 找到第一个有子菜单的一级菜单，选择其第一个子项
            const firstMenuWithChildren = rightMenu.find(menu => menu.children && menu.children.length > 0);
            console.log('firstMenuWithChildren:', firstMenuWithChildren);
            if (firstMenuWithChildren && firstMenuWithChildren.children.length > 0) {
                console.log('Setting bxmxq_id to:', firstMenuWithChildren.children[0].key);
                console.log('Setting openKeys to:', [firstMenuWithChildren.key]);
                setBxmxq_id(firstMenuWithChildren.children[0].key);
                setOpenKeys([firstMenuWithChildren.key]); // 展开第一个有子菜单的父菜单
            } else {
                setBxmxq_id(rightMenu[0].key);
                setOpenKeys([]);
            }
        }
    },[rightMenu,rightMenuSuccess])

    // 根据选中的bxmxq_id获取对应的单个数据项
    useEffect(() => {
        if(rightMenuSuccess && rightMenuData && rightMenuData.Status === 'success' && bxmxq_id){
            // 从key中提取原始的bxmbb_id
            const originalBxmbbId = bxmxq_id.replace('child_', '');
            
            // 找到对应的二级菜单数据项
            const findMenuDataItem = (children, targetId) => {
                for (let item of children) {
                    if (item.children) {
                        for (let child of item.children) {
                            if (child.bxmbb_id === targetId) {
                                return child; // 返回单个数据项而不是数组
                            }
                        }
                    }
                }
                return null;
            };
            
            const menuDataItem = findMenuDataItem(rightMenuData.Result.children, originalBxmbbId);
            setCurrentMenuData(menuDataItem);
        }
    },[rightMenuSuccess, rightMenuData, bxmxq_id])
    //默认选中第一个的需求名称
    const [bxmxq_name,setBxmxq_name] = useState('')
    useEffect(() => {
        if(rightMenuSuccess && rightMenu && rightMenu.length > 0){
            setBxmxq_name(rightMenu[0].label)
        }
    },[rightMenu,rightMenuSuccess])
    const navigate = useNavigate()
    return (
        <WebMain>         
            <div style={{width:'100%',display:'flex',justifyContent:'center',flexDirection:'column',alignItems:'center'}}>
                <a onClick={() => {navigate(`/SketchProject?bxm_id=${bxm_id}`)}} style={{textAlign:'center',color:'#fff',fontSize:'28px',fontWeight:'bold'}}>{bxm_name}</a>
                <div style={{minWidth:"1920px",maxWidth:"1920px",display:'flex',justifyContent:'center',gap:'10px'}}>
                    <div style={{
                        backgroundColor:'#fff',
                        padding:'20px',
                        borderRadius:'10px',
                        marginTop:"30px",
                        flex: 1,
                        maxWidth: '1580px'
                    }}>
                                  
                        {/* 模块列表 */}
                    {bxmxq_id ? (
                        <SketchDesc 
                            data={currentMenuData} 
                            bxm_id={bxm_id}
                            yh_name={yh_name}
                            bxmxq_name={bxmxq_name}
                            bxmbb_name={currentMenuData?.bxmbb_name || ''}
                            bxm_name={bxm_name}
                            yh_id={yh_id}
                        />
                    ) : (
                            <div style={{
                                textAlign: 'center',
                                padding: '100px 20px',
                                color: '#999',
                                fontSize: '16px'
                            }}>
                                <div style={{fontSize: '48px', marginBottom: '20px'}}>📋</div>
                                <div>请从右侧菜单选择功能模块查看详情</div>
                            </div>
                        )}
                    </div>
                    <div style={{
                        backgroundColor:'#fff',
                        padding:'10px',
                        borderRadius:'10px',
                        marginTop:"30px",
                        height:'fit-content',
                        minHeight:'auto',
                        flexShrink: 0,
                        maxWidth: '200px'
                    }}>
                        <Menu 
                            items={rightMenu}
                            onClick={(item) => {
                                console.log('Menu clicked:', item);
                                // 检查是否是一级菜单项（通过key前缀判断）
                                const isFirstLevel = item.key.startsWith('parent_');
                                
                                if (isFirstLevel) {
                                    // 一级菜单点击，设置为第一个子项的key
                                    const clickedMenu = rightMenu.find(menu => menu.key === item.key);
                                    if (clickedMenu && clickedMenu.children && clickedMenu.children.length > 0) {
                                        setBxmxq_id(clickedMenu.children[0].key);
                                        setOpenKeys([item.key]); // 展开当前点击的父菜单
                                    }
                                } else {
                                    // 二级菜单点击
                                    setBxmxq_id(item.key);
                                    // 找到这个二级菜单的父级菜单ID并展开
                                    const parentMenu = rightMenu.find(menu => 
                                        menu.children && menu.children.some(child => child.key === item.key)
                                    );
                                    if (parentMenu) {
                                        setOpenKeys([parentMenu.key]);
                                    }
                                }
                            }}
                            onOpenChange={(keys) => {
                                setOpenKeys(keys);
                            }}
                            mode="inline"
                            style={{width:'180px'}}
                            selectedKeys={[bxmxq_id]}
                            openKeys={openKeys}
                        />
                    </div>
                </div>
            </div>
        </WebMain>
    )
}

export default FrontSketchClient
